/**
 * The conference lifecycle, in one place.
 *
 * This list of seven statuses was written out by hand in three separate filter
 * dropdowns and one inline status editor, each with its own English labels.
 * Four copies of the same vocabulary is four chances for them to drift — and
 * they already had: the admin filter and the master-admin filter listed them in
 * different orders, and none of the labels were translatable.
 *
 * `statusOptions(t)` returns them ready for `<Select options={...} />`, with
 * labels resolved through the `conferences` namespace so they follow the
 * interface language like everything else.
 */

export const CONFERENCE_STATUSES = [
  'draft',
  'published',
  'submission_open',
  'submission_closed',
  'review_phase',
  'completed',
  'cancelled',
];

/** English fallbacks, used when a translation is missing. */
const FALLBACK = {
  draft: 'Draft',
  published: 'Published',
  submission_open: 'Submissions open',
  submission_closed: 'Submissions closed',
  review_phase: 'Review phase',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export function conferenceStatusOptions(t) {
  return CONFERENCE_STATUSES.map((value) => ({
    value,
    label: t ? t(`statuses.${value}`, FALLBACK[value]) : FALLBACK[value],
  }));
}

export function conferenceStatusLabel(value, t) {
  if (!value) return '';
  return t ? t(`statuses.${value}`, FALLBACK[value] || value) : FALLBACK[value] || value;
}

export default CONFERENCE_STATUSES;
